module.exports = __webpack_public_path__ + "img/3.23a94e81.png";